<div [class.chat-open-wrapper]="shouldApplyChatOpen">
  <div class="chat-icon" [ngStyle]="{
    bottom: isShortViewport ? '5px' : '20px'
  }" (click)="toggleChat()">
    <img loading="lazy" class="chatIconImg" src="../../../../../../assets/images/feature/Chat-bot-logo.png"
      alt="Chatbot" />
  </div>


  <div class="chat-box" [class.minimized]="isMinimized" [class.short-viewport]="isShortViewport"
    [class.expanded]="isExpanded && !isMinimized" [style.bottom]="isShortViewport ? '100px' : '105px'"
    *ngIf="isChatOpen" #chatBox>
    <!-- <div *ngIf="!isMobile()" class="cell-border-left"></div> -->
    <div class="chat-header">
      <!-- <img loading="lazy" class="header-left-icon" height="24" width="24" [src]="(isExpanded && !isMinimized)
    ? '../../../../../../assets/images/feature/Chat-bot-logo.png'
    : '../../../../../../assets/images/feature/more.png'" [ngStyle]="(isExpanded && !isMinimized)
    ? { width: '45px', height: '50px' }
    : { width: '24px', height: '24px' }" [alt]="(isExpanded && !isMinimized) ? 'Chatbot' : 'More'" /> -->
      <div class="header-left-icon-wrapper">
        <img *ngIf="isExpanded && !isMinimized" loading="lazy" height="50" width="45"
          src="../../../../../../assets/images/feature/Chat-bot-logo.png" alt="Chatbot" />
      </div>


      <!-- (click)="toggleMenu()" -->
      <span class="chat-title text-xl">ChatD&amp;B</span>

      <!-- <div class="header-right-icons">
      <img loading="lazy" [ngClass]="{'img-margin-top': isMinimized}" (click)="toggleMinimize()" [height]="isMinimized ? '18' : '24'" [width]="isMinimized ? '18' : '24'" [src]="isMinimized
          ? '../../../../../../assets/images/feature/maximize_icon.png'
          : '../../../../../../assets/images/feature/message-minus.png'" alt="Toggle" />
      <img loading="lazy" (click)="toggleWidth()" height="16" width="16" [src]="isExpanded
                 ? '../../../../../../assets/images/feature/collapse_chat.png'
          : '../../../../../../assets/images/feature/expan-icon-chat.png'" alt="Resize" [ngClass]="isMinimized ? 'img-margin-top' : 'img-margin-small'"/>

      <img loading="lazy" (click)="toggleChat()" height="28" width="28"
        src="../../../../../../assets/images/feature/message-minus-1.png" alt="Close" />
    </div> -->
      <div class="header-right-icons">
        <!-- Minimize / Maximize -->
        <!-- Bootstrap tooltip on icon -->


        <img loading="lazy" [ngClass]="{'img-margin-top': isMinimized}" (click)="toggleMinimize()"
          [height]="isMinimized ? '18' : '24'" [width]="isMinimized ? '18' : '24'" [src]="isMinimized
        ? '../../../../../../assets/images/feature/maximize_icon.png'
        : '../../../../../../assets/images/feature/message-minus.png'" alt="Toggle"
          tooltip="{{ isMinimized ? 'Maximize' : 'Minimize' }}"
          [placement]="isMinimized ? 'left' : (isExpanded ? 'bottom' : 'bottom')" />

        <!-- Expand / Collapse -->
        <!-- When expanded: container = null -->
        <img *ngIf="isExpanded" loading="lazy" (click)="toggleWidth()" height="16" width="16"
          src="../../../../../../assets/images/feature/collapse_chat.png" alt="Resize"
          [ngClass]="isMinimized ? 'img-margin-top' : 'img-margin-small'" tooltip="Collapse Chat"
          [placement]="isMinimized ? 'left' : 'bottom'" [container]="null" />

        <!-- When not expanded: container = 'body' -->
        <img *ngIf="!isExpanded" loading="lazy" (click)="toggleWidth()" height="16" width="16"
          src="../../../../../../assets/images/feature/expan-icon-chat.png" alt="Resize"
          [ngClass]="isMinimized ? 'img-margin-top' : 'img-margin-small'" tooltip="Expand Chat"
          [placement]="isMinimized ? 'left' : 'bottom'" container="body" />


        <!-- Close -->
        <!-- When expanded: container = 'body' -->
        <img *ngIf="isExpanded" loading="lazy" (click)="toggleChat()" height="28" width="28"
          src="../../../../../../assets/images/feature/message-minus-1.png" alt="Close"
          [placement]="isExpanded || isMinimized ? 'left' : 'bottom'" tooltip="Close chat" [container]="null" />

        <!-- When not expanded: container = null -->
        <img *ngIf="!isExpanded" loading="lazy" (click)="toggleChat()" height="28" width="28"
          src="../../../../../../assets/images/feature/message-minus-1.png" alt="Close"
          [placement]="isMinimized ? 'left' : 'bottom'" tooltip="Close chat" container="body" />

      </div>


    </div>

    <div class="chat-body" #chatBody>
      <!-- overlay -->

      <!-- <div class="chat-body-menu" [class.open]="showMenu">
      <ul>
        <a href="https://www.dnb.com/en-us/why-dnb/data-transparency/ai-systems.html" target="_blank"
          rel="noopener noreferrer" class="ai-trust-button-overlay">
          <img src="../../../../../../assets/images/feature/ai-trust-centre.png" alt="D&B Icon" class="button-icon" />
          <span>AI Trust Centre</span>
        </a>
      </ul>
    </div> -->
      <div class="ai-trust-header">
        <div class="ai-trust-header-inner">

          <a href="https://www.dnb.com/en-us/why-dnb/data-transparency/ai-systems.html" target="_blank"
            rel="noopener noreferrer" class="ai-trust-button">
            <img loading="lazy" src="../../../../../../assets/images/feature/ai-trust-centre.png" alt="D&B Icon"
              class="button-icon" />
            <span>AI Trust Centre</span>
          </a>

          <svg placement="bottom" tooltip="New chat" (click)="startNewChat()"
            class="right-info-icon MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-vz303y" focusable="false"
            aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
            <path d="M18.375 2.625a2.121 2.121 0 1 1 3 3L12 15l-4 1 1-4Z"></path>
          </svg>
          <!-- <img src="../../../../../../assets/images/feature/new-chat-black.png"
         alt="Info Icon"
         class="right-info-icon" /> -->

        </div>
      </div>
      <!-- <div class="chat-body-content"> -->
      <div class="chat-body-inner">
        <div *ngIf="showWelcome" class="welcome-box-container">
          <img loading="lazy" src="../../../../../../assets/images/feature/dnb-chat-logo.png" alt="D&B"
            class="welcome-icon" />

          <div class="welcome-box">
            <div class="welcome-message text-color">
              <p>
                Welcome to <span class="bold">ChatD&amp;B</span> for Customer Service.
                We’re here to help you with any questions you might have regarding getting support from D&B.
                Note that we cannot answer any data-specific questions that might require a subscription.
              </p>
            </div>
          </div>
        </div>
        <div *ngIf="!showWelcome">
          <div *ngFor="let msg of messages; let i = index" [ngClass]="msg.sender === 'user' ? 'user-msg' : 'bot-msg'">
            <div class="message-bubble">
              <strong *ngIf="msg.sender === 'bot' && (msg.text || isStreaming)">ChatD&amp;B</strong>
              <div *ngIf="msg.sender === 'bot' && isStreaming && i === messages.length - 1 && !msg.text">
                <img class="lazy" src="../assets/images/common/ampersand-loader-mini.gif" alt="loading indicator" />
              </div>
              <p>{{ msg.text }}</p>
              <div class="col-sm-12 pl-0 pt-2 mt-2 helpfulCls"
                *ngIf="msg.sender === 'bot' && !isStreaming && feedbackMap[i] === undefined && !pendingThumbDown[i]">
                <div class="text-md pr-3 title-color">
                  Was this helpful?
                  <span class="text-md">
                    <img class="mr-2 ml-2 pointer" height="24" width="24"
                      [src]="feedbackMap[i] === 1 ? '../assets/images/feature/thumb_up_filled.png' : '../assets/images/feature/thumb_up.png'"
                      alt="thumb_up" (click)="submitFeedback(i, 1)" />

                    <img class="pointer mt-1" height="24" width="24"
                      [src]="feedbackMap[i] === 2 ? '../assets/images/feature/thumb_down_filled.png' : '../assets/images/feature/thumb_down.png'"
                      alt="thumb_down" (click)="pendingThumbDown[i] = true" />
                  </span>
                </div>
              </div>

              <div
                *ngIf="msg.sender === 'bot' && (feedbackMap[i] === 1 || pendingThumbDown[i] || submittedNegativeFeedback[i])"
                class="welcome-box-container">
                <div class="feedback-box">
                  <div class="welcome-message text-color">
                    <ng-container *ngIf="feedbackMap[i] === 1">
                      <img width="24" height="24" alt="success_large"
                        src="../../../../../../assets/images/feature/success_large.png" /> &nbsp;
                      <span>Thank you for your feedback!</span>
                      <div class="pt-2">We're glad that it was helpful.</div>
                    </ng-container>
                    <ng-container *ngIf="pendingThumbDown[i] && !submittedNegativeFeedback[i]">
                      <p class="fbMsg pb-2">We're always striving to improve, so your feedback helps a lot.</p>
                      <textarea [(ngModel)]="feedbackReasonText[i]" class="feedback-textarea" placeholder="Feedback Optional"></textarea>
                      <button class="btn btn-primary btn-height fbSubmit mt-2"
                        (click)="submitFeedback(i, 2, feedbackReasonText[i])">Submit</button>
                    </ng-container>
                    <ng-container *ngIf="submittedNegativeFeedback[i]">
                      <img width="24" height="24" alt="success_large"
                        src="../../../../../../assets/images/feature/success_large.png" /> &nbsp;
                      <span>Thank you for your feedback!</span>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <!-- </div> -->
      <!-- <div class="chat-body-overlay show" *ngIf="showMenu" (click)="closeMenu()"></div> -->

    </div>
    <div class="chat-promt">
      <div class="input-container">
        <!-- <div class="chat-input-fake-textarea">
        <div *ngIf="selectedFileName" class="file-line" contenteditable="false">
          <span>{{ selectedFileName }}</span>
          <button class="remove-btn" (click)="removeAttachment()">✖</button>
          <img class="remove-btn" (click)="removeAttachment()" height="28" width="28"
         src="../../../../../../assets/images/feature/message-minus-1.png" alt="Close" /> 
        </div>
        <div
          class="user-input"
          contenteditable="true"
          [attr.placeholder]="'Ask ChatD&B...'"
          #userInput
          (keydown.enter)="onMessageEnter()"
        ></div>
      </div> -->
        <!-- <textarea placeholder="Ask ChatD&B" [(ngModel)]="inputMessage" (keydown.enter)="onMessageEnter()"  #textarea
          class="chat-textarea"></textarea> -->
        <textarea class="chat-textarea" placeholder="Ask ChatD&B" #field [(ngModel)]="inputMessage"
           (keydown.enter)="!isStreaming && handleEnter($event)" (keyup)="rows(field.value)" [rows]="rows(field.value)" [cols]="size">
          </textarea>

        <!-- <div class="input-icons">
        <img src="../../../../../../assets/images/feature/Vector.png" alt="sendIcon" (click)="onMessageEnter()" />
        <img src="../../../../../../assets/images/feature/Group.png" alt="attachmentIcon" (click)="fileInput.click()" />
        <input type="file"
               #fileInput
               accept=".pdf,.doc,.docx"
               style="display: none"
               (change)="onFileSelected($event)" />
        <img src="../../../../../../assets/images/feature/Frame.png" alt="voiceIcon" (click)="startVoiceInput()" />
      </div> -->


        <div class="input-icons">
          <img src="../../../../../../assets/images/feature/Vector.png" alt="sendIcon" (click)="onMessageEnter()"
            class="send-icon" [class.disabled]="!inputMessage.trim() || isStreaming" />


          <!-- <img src="../../../../../../assets/images/feature/Group.png" alt="attachmentIcon" (click)="fileInput.click()" />
        <input type="file"
               #fileInput
               accept=".pdf,.doc,.docx"
               style="display: none"
               (change)="onFileSelected($event)" />
        <img src="../../../../../../assets/images/feature/Frame.png" alt="voiceIcon" (click)="startVoiceInput()" /> -->
        </div>
      </div>
    </div>
    <div class="chat-footer">
      <span class="powered-by text-md">Powered by D&B</span>
    </div>
  </div>